// styles
require('./personeticsSubscribtionErrorModal.scss');
require('./personeticsSubscribtionErrorModal.override.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const OKModal = require('components/commons/OKModal/OKModal');
const { formatText } = require('core/i18n').i18n;
// @assets
const IconError = require("assets/images/icon-error.svg");

class PersoneticsSubscriptionErrorModal extends React.Component {

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        const { handleSubmit } = this.props;
        handleSubmit();
    }

    buildModalErrorContent() {
        const { title, description } = this.props;
        return (
            <ContentBox
                title={title}
                titleSeparator={true}
                leftIcon={{icon: IconError}}
                customClassName="personetics-subscription-error-modal"
                hasShadow={false}
            >
                <div className="personetics-subscription-error-modal__wrapper">
                    <p className="personetics-subscription-error-modal__text">{description}</p>
                </div>
            </ContentBox>
        );
    }

    buildModal() {
        const { showModal } = this.props;

        return (
            <OKModal
                content={this.buildModalErrorContent()}
                contentOverflow="auto"
                footerType="navigation"
                isOpen={showModal}
                customCloseButton={<div/>}
                shouldCloseOnOverlayClick={false}
                onPrimaryButtonClick={this.handleSubmit}
                hideHeader={true}
                primaryButtonText={formatText('personeticsSubscriptionErrorModal-errorModalBtnText')}
                overlayClassName="personetics-subscription-error-modal"
            />
        )
    }

    render() {
        return (
            <div>
                {this.buildModal()}
            </div>
        )
    }
}

PersoneticsSubscriptionErrorModal.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

module.exports = PersoneticsSubscriptionErrorModal;
